import { Boolean, Record, Static } from "runtypes";

export const SettingsRunType = Record({
  printDeveloperMode: Boolean,
});

export interface ISettings extends Static<typeof SettingsRunType> {}



// WEBPACK FOOTER //
// ./src/services/ISettings.ts